import { render, staticRenderFns } from "./json-ld-faq.vue?vue&type=template&id=d866b962&"
import script from "./json-ld-faq.vue?vue&type=script&lang=js&"
export * from "./json-ld-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports